import { render, staticRenderFns } from "./Exams.vue?vue&type=template&id=230b7b9a"
import script from "./Exams.vue?vue&type=script&lang=js"
export * from "./Exams.vue?vue&type=script&lang=js"
import style0 from "./Exams.vue?vue&type=style&index=0&id=230b7b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports